import { getTemplateNavHeaderStyles } from './NavHeader.styles'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'

const t = document.createElement('template')
t.innerHTML = `
<wa-details exportparts="base,header,summary,content,icon" class="contextual-dropdown-item">
  <slot></slot>
</wa-details>
`

class NavHeaderContextualMenuItem extends HTMLElement {
  private waDetails: HTMLElement | null = null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Details])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    this.waDetails = shadow.querySelector('wa-details')
  }

  connectedCallback() {
    // Forward all attributes to wa-details
    if (this.waDetails) {
      for (const attr of this.attributes) {
        this.waDetails.setAttribute(attr.name, attr.value)
      }

      // Add click listener to handle selection
      this.waDetails.addEventListener('click', (e) => {
        e.stopPropagation()

        document.dispatchEvent(
          new CustomEvent('navheader-menu-item-selected', {
            detail: { selectedElement: this },
          }),
        )

        // Toggle selected state on current element
        this.waDetails?.classList.toggle('selected-menu-item')
      })
    }

    // Listen for selection events from other menu items
    document.addEventListener('navheader-menu-item-selected', (e: Event) => {
      const customEvent = e as CustomEvent
      if (customEvent.detail.selectedElement !== this) {
        this.waDetails?.classList.remove('selected-menu-item')
      }
    })

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target as Node)) {
        this.waDetails?.classList.remove('selected-menu-item')
      }
    })
  }
}

customElements.define('ts-navheader-contextual-menu-item', NavHeaderContextualMenuItem)
